<div *ngIf="notification" class="notification-container" [@slideInOut]="notification ? 'visible' : 'void'">
  <div class="notification-content">
    <span class="notification-message">{{ notification.message }}</span>
    <button class="notification-close" (click)="closeNotification()">ОК</button>
  </div>
</div>